import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Star, Clock, MapPin, Leaf, ChevronLeft, Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

import { API } from '../config';

const StationRestaurants = () => {
  const { code } = useParams();
  const nav = useNavigate();
  const [rests, setRests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [veg, setVeg] = useState(false);
  const [q, setQ] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const r = await axios.get(`${API}/restaurants?station=${code}`);
        setRests(r.data);
      } catch (e) { /* ignore */ }
      finally { setLoading(false); }
    };
    load();
  }, [code]);

  const filtered = rests.filter(r => (!veg || r.veg) && r.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <button onClick={()=>nav(-1)} className="flex items-center gap-1 text-sm text-gray-500 hover:text-tp-orange mb-3">
        <ChevronLeft size={16} /> Back
      </button>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-full bg-[#0B2E5C] text-white flex items-center justify-center font-bold">{code}</div>
        <div>
          <h1 className="text-2xl font-bold text-[#0B2E5C]">Restaurants at {code}</h1>
          <p className="text-sm text-gray-500 flex items-center gap-1"><MapPin size={12} /> Select a restaurant to see menu</p>
        </div>
      </div>

      <div className="bg-white border border-gray-100 rounded-xl p-4 flex flex-col sm:flex-row gap-3 items-stretch sm:items-center mb-5">
        <div className="flex items-center gap-2 border-2 border-gray-200 rounded-lg px-3 flex-1 focus-within:border-[#0B2E5C]">
          <Search size={16} className="text-gray-400" />
          <Input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search restaurants" className="border-0 focus-visible:ring-0 h-10" />
        </div>
        <Button onClick={()=>setVeg(!veg)} variant={veg ? 'default' : 'outline'} className={veg ? 'bg-green-600 hover:bg-green-700 text-white' : 'border-green-500 text-green-700 hover:bg-green-50'}>
          <Leaf size={14} className="mr-1" /> Pure Veg
        </Button>
      </div>

      {loading ? <div className="text-center py-10 text-gray-500">Loading restaurants...</div> : (
        filtered.length === 0 ? (
          <div className="text-center py-16 text-gray-500">No restaurants found at {code}. Try another station.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map(r => (
              <button key={r.id} onClick={()=>nav(`/food/restaurant/${r.id}`)} className="bg-white border border-gray-100 rounded-xl overflow-hidden card-shadow hover:-translate-y-0.5 transition-transform text-left">
                <div className="h-40 bg-gray-100 relative">
                  <img src={r.image} alt={r.name} className="w-full h-full object-cover" />
                  <div className="absolute top-2 left-2">
                    <span className={`inline-block w-5 h-5 border-2 ${r.veg ? 'border-green-600' : 'border-red-600'} bg-white flex items-center justify-center`}>
                      <span className={`w-2 h-2 rounded-full ${r.veg ? 'bg-green-600' : 'bg-red-600'}`} />
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-[#0B2E5C]">{r.name}</h3>
                  <div className="text-xs text-gray-500 mt-0.5">{r.cuisines?.join(', ')}</div>
                  <div className="flex items-center gap-3 mt-2 text-xs">
                    <span className="flex items-center gap-1 bg-green-600 text-white px-1.5 py-0.5 rounded"><Star size={10} fill="white" /> {r.rating}</span>
                    <span className="flex items-center gap-1 text-gray-500"><Clock size={12} /> {r.time}</span>
                    <span className="text-gray-500">₹{r.price} for two</span>
                  </div>
                  <div className="text-[11px] text-gray-400 mt-2">FSSAI: {r.fssai}</div>
                </div>
              </button>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default StationRestaurants;
